<div class="microsites-subheader-container" *ngIf="path == 'microsites'">
  <div class="microsites-title-wrapper">
    <span *ngIf="path == 'microsites'" class="microsites-title">Microsites</span>
  </div>
  <div class="create-microsites-button-wrapper" *ngIf="micrositesService.showCreateMicrositesButton">
    <button mat-raised-button class="create-microsites-button"
      (click)="micrositesService.openAddMicrositePopup()">Create microsite</button>
  </div>
</div>
